<ul
    app-submenu
    [item]="this.app.model"
    root="true"
    class="layout-menu layout-main-menu clearfix ml-1 mt-1"
    [reset]="reset"
    visible="true"
    parentActive="true"
    style="padding-bottom: 0 !important;"
></ul>
<!-- <ul
    app-submenu
    [item]="cpModel"
    root="true"
    class="layout-menu layout-main-menu clearfix"
    [reset]="reset"
    visible="true"
    parentActive="true"
    style="padding-bottom: 0 !important"
></ul> -->
